import {
  FORM_OBJECT_REQUESTING,
  GET_FORM_SUCCESS,
  RESET_FORM_ISFETCHING
  // SUBSCRIBE_FORM_SUCCESS,
  // FEEDBACK_FORM_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FORM_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case RESET_FORM_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false
      };
    }
    case GET_FORM_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    // case FEEDBACK_FORM_SUCCESS: {
    //   return {
    //     data: { ...action.payload },
    //     isFetching: false
    //   };
    // }
    // case SUBSCRIBE_FORM_SUCCESS: {
    //   return {
    //     data: { ...action.payload },
    //     isFetching: false
    //   };
    // }
    default:
      return state;
  }
};

export default reducer;

export const getFormByCode = (forms, code) => {
  if (!forms.data) {
    return null;
  }
  const formIds = Object.keys(forms.data);
  const formByCodeId = formIds.find((id) => forms.data[id].code === code);
  if (formByCodeId) {
    return forms.data[formByCodeId];
  }
  return null;
};
